import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-council-committee',
  templateUrl: './student-council-committee.component.html',
  styleUrls: ['./student-council-committee.component.scss']
})
export class StudentCouncilCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
